import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as actions from "./../../../../actions/forgotPassword.actions";
import * as commonActions from "./../../../../actions/common.actions";
import ForgotPassword from "../components/ForgotPassword";

class ForgotPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillUnmount() {
    this.props.commonActions.showError(null);
  }

  handleSubmit(data) {
    this.props.actions.resetPassword(data);
  }

  render() {
    return (
      <ForgotPassword
        onSubmit={this.handleSubmit}
        location={this.props.location}
      />
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordContainer);



// WEBPACK FOOTER //
// ./src/routes/common/ForgotPassword/containers/ForgotPasswordContainer.js